import React, { Component } from "react";
import styles from "./trips.module.scss";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import Scrollbars from "react-custom-scrollbars-2";
import { states } from "../../../reducers/queriesStates";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import SettingsIcon from "@mui/icons-material/Settings";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import { withLogisticTripControlPoints } from "../../../shared/containers/containerLogisticTripControlPoints";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import { v4 as uuidv4 } from "uuid";
import getDates from "../../../shared/services/date.service";

class TripRoutesList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routes: [],
    };
  }

  componentDidMount() {
    const { logisticSelectedTrip } = this.props;

    if (logisticSelectedTrip !== null) {
      const routes = logisticSelectedTrip.routes.map((x) => {
        return Object.assign({}, x, {
          isViewControlPoints: true,
        });
      });

      this.setState({ routes });
    }
  }

  componentDidUpdate(preProps) {
    const { logisticTripDataState, logisticSelectedTrip, logisticUpdateTripControlPointVariationDataState, onGetLogisticTrip } = this.props;

    const { routes } = this.state;

    if (logisticTripDataState === states.READY && preProps.logisticTripDataState === states.REQUEST) {
      const _routes = logisticSelectedTrip.routes.map((x) => {
        const route = routes.filter((r) => {
          return r.id === x.id;
        })[0];

        return Object.assign({}, x, {
          isViewControlPoints: route !== undefined ? route.isViewControlPoints : false,
        });
      });

      this.setState({ routes: _routes });
    }

    if (
      logisticUpdateTripControlPointVariationDataState === states.READY &&
      preProps.logisticUpdateTripControlPointVariationDataState === states.REQUEST
    ) {
      onGetLogisticTrip({ id: logisticSelectedTrip.id });
    }
  }

  onColapseToolClick(route) {
    const { routes } = this.state;

    const _routes = routes.map((x) => {
      if (x.id === route.id) {
        x.isViewControlPoints = !x.isViewControlPoints;
      }

      return x;
    });

    this.setState({ routes: _routes });
  }

  render() {
    const { routes } = this.state;
    const { onSetControlPointVariation, onSetControlPointAlarm, onSetTripRouteAlarmView, tripCPPermission } = this.props;
    const height = window.innerHeight > 800 ? 650 : 450;

    let count = 0;

    return (
      <div className={styles.tripRouteList} style={{ width: "60%" }}>
        <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
          {routes.map((route, index) => {
            return (
              <div key={uuidv4()}>
                <div
                  key={uuidv4()}
                  className={styles.tripRouteListItem}
                  style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onColapseToolClick(route);
                  }}
                >
                  <div>{route.isViewControlPoints ? <UnfoldMoreIcon fontSize="small" /> : <UnfoldLessIcon fontSize="small" />}</div>
                  <div className={styles.titleRoute}>{route.title}</div>

                  <div
                    class={styles.alarmRouteTimeContainer}
                    style={{ color: route.alarm !== null && route.alarm.active !== null ? "#157fe1" : "" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onSetTripRouteAlarmView(true, route);
                    }}
                  >
                    <TooltipWrapper title={`Изменить расписание маршрута "${route.title}"`} position="top">
                      <div>
                        {route.alarm.active === null ? (
                          <div className={styles.alarmRouteTime}>
                            <AlarmOffIcon fontSize="small" />
                          </div>
                        ) : null}

                        {route.alarm.active !== null && !route.alarm.active ? (
                          <div className={styles.alarmRouteTime} style={{ color: "#08233073" }}>
                            <AlarmOffIcon style={{ color: "#157fe1" }} fontSize="small" />
                            <div>
                              {" "}
                              C {getDates.hoursAndMinutes(route.alarm.time)} по{" "}
                              {getDates.timeAddMinuts(route.alarm.time, route.alarm.duration)}{" "}
                            </div>
                          </div>
                        ) : null}

                        {route.alarm.active !== null && route.alarm.active ? (
                          <div className={styles.alarmRouteTime}>
                            <AlarmOnIcon style={{ color: "#157fe1" }} fontSize="small" />
                            <div>
                              {" "}
                              C {getDates.hoursAndMinutes(route.alarm.time)} по{" "}
                              {getDates.timeAddMinuts(route.alarm.time, route.alarm.duration)}{" "}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </TooltipWrapper>
                  </div>
                </div>

                {route.isViewControlPoints ? (
                  <div className={styles.tripRouteControlPointsOpenContainer}>
                    {route.controlPoints.map((controlPoint) => {
                      const number = count + 1;
                      return (
                        <div key={uuidv4()} className={styles.item}>
                          <div>
                            {tripCPPermission ? (
                              <div
                                style={{ color: controlPoint.isVariation ? "#157fe1" : "" }}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  onSetControlPointVariation(controlPoint, route, number);
                                }}
                              >
                                <TooltipWrapper title={`Изменить параметры контрольной точки "${controlPoint.title}"`} position="top">
                                  <SettingsIcon fontSize="small" />
                                </TooltipWrapper>
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>

                          <div> {++count}.</div>
                          <div className={styles.title}> {controlPoint.title}</div>
                          <div className={styles.address}> {controlPoint.address}</div>

                          <div
                            className={styles.itemTools}
                            style={{ color: controlPoint.alarm !== null && controlPoint.alarm.active !== null ? "#157fe1" : "" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              onSetControlPointAlarm(controlPoint, route);
                            }}
                          >
                            <TooltipWrapper title={`Изменить расписание контрольной точки "${controlPoint.title}"`} position="top">
                              <div>
                                {controlPoint.alarm.active === null ? <AlarmOffIcon fontSize="small" /> : null}

                                {controlPoint.alarm.active !== null && !controlPoint.alarm.active ? (
                                  <div style={{ display: "flex", color: "#08233073" }}>
                                    <AlarmOffIcon style={{ color: "#157fe1" }} fontSize="small" />
                                    <div>
                                      C {getDates.hoursAndMinutes(controlPoint.alarm.time)} по{" "}
                                      {getDates.timeAddMinuts(controlPoint.alarm.time, controlPoint.alarm.duration)}{" "}
                                    </div>
                                  </div>
                                ) : null}

                                {controlPoint.alarm.active !== null && controlPoint.alarm.active ? (
                                  <div style={{ display: "flex" }}>
                                    <AlarmOnIcon style={{ color: "#157fe1" }} fontSize="small" />
                                    <div>
                                      C {getDates.hoursAndMinutes(controlPoint.alarm.time)} по{" "}
                                      {getDates.timeAddMinuts(controlPoint.alarm.time, controlPoint.alarm.duration)}{" "}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </TooltipWrapper>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
              </div>
            );
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default withLogisticTripControlPoints(withLogisticTrips(React.memo(TripRoutesList)));
